import React from "react";
import styled from "styled-components";
import { IC } from "../../../resources/Assets";

const StatusCircleText = (props) => {
  return (
    <Container>
      <img src={IC.etc.ICON_CIRCLE_POINT_PURPLE} />
      <Text>{props.text}</Text>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Text = styled.div`
  color: var(--Primary, #6b65de);

  /* Body/3/Regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;
`;
export default StatusCircleText;
